export interface QuickBooksLogRecordConstructor {
  id: number
  description: string
  timestamp: Date // rendered as long-form date (LLLL)
  modelType: string // internal_type.model, lowercase, e.g. 'itemreceipt'
}

export class QuickBooksLogRecord {
  readonly id: number
  readonly description: string
  readonly timestamp: Date
  readonly modelType: string

  constructor(data: QuickBooksLogRecordConstructor) {
    this.id = data.id
    this.description = data.description
    this.timestamp = data.timestamp
    this.modelType = data.modelType
  }
}
